var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSickLeaveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione-monotone",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 43.498,
    cy: 30.307,
    r: 5,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.578 15.213a14.235 14.235 0 0 1-11.694 3.133c-.578-.113-1.088 2.021-.385 2.156a16.424 16.424 0 0 0 13.493-3.615c.541-.469-.971-2.061-1.414-1.674",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.113 18.193c-4.168.748-8.455-.4-11.691-3.133c-.443-.389-1.955 1.205-1.412 1.674a16.418 16.418 0 0 0 13.492 3.615c.703-.134.191-2.269-.389-2.156",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32 2C15.432 2 2 15.432 2 32c0 .515.013 1.025.039 1.533c-.081.768-.02 1.54.211 2.281C4.125 50.58 16.725 62 32 62c16.568 0 30-13.432 30-30S48.568 2 32 2M10.206 30.283l21.396 16.791c-.248.156-.494.316-.735.484L10.424 32c-.383-.272-1.359.442-2.172 1.596s-1.159 2.309-.774 2.582l8.94 5.834l.76-1.077l.893.563l-.769 1.09l1.627 1.063l.711-1.01l.893.565l-.721 1.021l1.627 1.061l.652-.926l.891.567l-.659.936l1.626 1.062l.605-.857l.889.571l-.609.862l1.625 1.062l.559-.792l.887.574l-.561.794l.898.587c-.206.202-.41.405-.608.616l-.788-.497l-.475.674l-.885-.576l.467-.662l-1.644-1.037l-.526.746l-.887-.573l.521-.737l-1.644-1.037l-.629.893l-.891-.568l.627-.889l-1.643-1.037l-.619.877l-.891-.563l.618-.876l-1.644-1.038l-.627.889l-.893-.566l.626-.887l-10.021-6.332c-3.691-2.606.729-8.87 4.42-6.265M32 59.5c-12.616 0-23.265-8.545-26.488-20.148l21.017 12.281c-.088.111-.181.22-.267.333c-.881 1.195 2.232 3.514 3.107 2.315c2.377-3.143 6.783-6.198 12.268-6.481c1.469-.075 1.404-3.925-.17-3.867c-2.936.14-5.793.937-8.367 2.275L20.102 35.267c.133.011.261.04.396.04a5 5 0 1 0-5-5c0 .426.069.832.169 1.227l-3.855-3.245c-2.514-1.774-5.181-1.216-7.1.382C6.361 15.072 17.965 4.5 32 4.5c15.164 0 27.5 12.336 27.5 27.5S47.164 59.5 32 59.5",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSickLeaveIcon);
export default __webpack_public_path__ + "static/media/sickLeaveIcon.8b7ec4f2c7ec74382bc0d1c1fcfd3065.svg";
export { ForwardRef as ReactComponent };